import { component } from 'picoapp';
import KeenSlider from 'keen-slider';

export default component(async (node, ctx) => {
  const slider = node.querySelector('[data-slider]');
  const dots = node.querySelectorAll('[data-slider-dot]');

  function updateClasses(instance) {
    const { relativeSlide } = instance.details();

    dots.forEach((dot) => dot.classList.remove('is-active'));
    dots[Number.isNaN(relativeSlide) ? 0 : relativeSlide].classList.add('is-active');
  }

  /* eslint-disable no-new */
  const keen = new KeenSlider(slider, {
    spacing: 15,
    slidesPerView: 1,
    autoAdjustSlidesPerView: false,
    created: (instance) => {
      updateClasses(instance);
    },
    slideChanged: (instance) => {
      updateClasses(instance);
    },
  });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      keen.moveToSlide(index);
    });
  });

  node.addEventListener('click', (event) => {
    if (event.target.hasAttribute('data-lightbox')) {
      event.preventDefault();

      const { index } = event.target.dataset;
      ctx.emit('lightbox:open', { index });
    }
  });
});
